(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forher-gift2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var items = document.querySelectorAll('.p-lineup__item-linkwrap');
    
    items.forEach(function(item) {
        item.addEventListener('click', function(event) {
            event.preventDefault();

            var parentItem = this.closest('.p-lineup__item');
            var acc = parentItem.querySelector('.c-acc');

            if (acc) {
                acc.classList.toggle('open');
            }

            this.classList.toggle('open');
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forher-main-cart2"]) return;
  try {
    
/*=================================================
     全商品削除
===================================================*/
document.addEventListener('DOMContentLoaded', function() {
const clearCartButton = document.getElementById('clear-cart-button');
  
  clearCartButton.addEventListener('click', function() {
    // カート内のすべてのアイテムを削除するためのリクエストを送信
    fetch('/cart/clear.js', {
      method: 'POST',
    })
    .then(response => response.json())
    .then(data => {
      window.location.reload();
    })
    .catch(error => console.error('Error clearing cart:', error));
  });
});
/*=================================================
     カートの削除
===================================================*/

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.button--delete').forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const setIdToDelete = this.getAttribute('data-set-id'); // 削除対象のセットIDを取得
      console.log(setIdToDelete);
      if (setIdToDelete) {
        removeRelatedItems(setIdToDelete);
      }
    });
  });
    
  // 指定したデザインIDを持つすべてのアイテムを削除する関数
  async function removeRelatedItems(setIdToDelete) {
    try {
      // カートの現在のアイテムを取得
      let response = await fetch('/cart.js');
      let cart = await response.json();
  
      // 同じセットIDを持つアイテムを取得し、削除リストを作成
      let updates = {};
      let parentProductUpdated = false;
      cart.items.forEach(item => {
        if (item.properties && item.properties['親セットID'] == setIdToDelete) {
          updates[item.key] = 0; // このアイテムを削除するように設定
        }
        if (item.properties['セットID'] == setIdToDelete && !parentProductUpdated) {
          updates[item.key] = 0; // このアイテムを削除するように設定
          let parentProductUpdated = true; // 親商品が更新されたことをマーク
        }
      });
      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        window.location.reload();
      } else {
        console.log('削除するアイテムが見つかりませんでした。');
      }
  
      // カートをリロードして削除を反映
      window.location.reload();
    } catch (error) {
      console.error('アイテムの削除に失敗しました:', error);
    }
  };
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.quatity_change').forEach(button => {
    button.addEventListener('click', async function (event) {
      const isIncrease = this.name === 'plus';
      const setIdToUpdate = this.getAttribute('data-set-id'); // セットIDを取得
      const itemList = this.getAttribute('itemlist'); // 内訳を取得
      const nextQuantity = parseInt(this.getAttribute('nextquantity')); // 次の数量を取得
      
      // 内訳を解析し、商品名ごとの出現回数をカウント
      let productCount = {};
      itemList.split(', ').forEach(itemName => {
        productCount[itemName] = (productCount[itemName] || 0) + 1;
      });

      // カートの現在のアイテムを取得
      let response = await fetch('/cart.js');
      let cart = await response.json();

      // 「親セットID」が一致する商品、及び親商品自身の数量を更新
      let updates = {};
      let parentProductUpdated = false;
      cart.items.forEach(item => {
        if (item.properties['親セットID'] == setIdToUpdate) {
          const itemName = item.product_title.trim();
          const targetQuantity = (productCount[itemName] || 0) * nextQuantity;
          updates[item.key] = targetQuantity; // 個数を「内訳の回数 × 次の数量」に設定
        }
        if (item.properties['セットID'] == setIdToUpdate && !parentProductUpdated) {
          updates[item.key] = nextQuantity; // 親商品自身の数量も更新
          parentProductUpdated = true; // 親商品が更新されたことをマーク
        }
      });

      // サーバーにカート更新リクエストを送信
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });

      // ページをリロードして変更を反映
      window.location.reload();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopify-lp-gift"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.lp-accordion').forEach(function(accordion) {
    accordion.addEventListener('click', function() {
      var wrapper = this.closest('.lp-accordion-wrapper');
      var innerContent = wrapper.querySelector('.lp-accordion-inner');
      wrapper.classList.toggle('open');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
